import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData } from '../../../types'
import { CmsConverterService, defaultLinkData } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedPdfsLinkConverter extends CmsConverterService<PanelRowRelatedPdfsLinkData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const link = formData.st_panel_row_related_pdf_link ?? defaultLinkData
    return {
      link: {
        ...link,
        assetName: link.assetName || link.text || ''
      }
    }
  }
}

export const PANEL_ROW_RELATED_PDFS_LINK_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedPdfsLinkData>>('PanelRowRelatedPdfsLinkConverter')

export interface PanelRowRelatedPdfsLinkData extends ConvertedComponentData {
  link: LinkData;
}
